import { useApolloClient } from "@apollo/client";
import { LoadingOverlay, Select } from "@mantine/core";
import { useEffect, useState } from "react";
import { showNotification } from "@mantine/notifications";
import { GET_RETAILERS } from "apollo/queries";

export default function RetailerFilter({
  onCardClick,
  retailer,
  required,
  valueType,
  setRetailerName,
}) {
  const client = useApolloClient();

  const [dropDownData, setDropDownData] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadAllRetailers = async () => {
    try {
      setLoading(true);

      const allRetailers = [];

      let page = 1;
      let hasMorePages = true;

      while (hasMorePages) {
        const { data } = await client.query({
          query: GET_RETAILERS,
          variables: {
            first: 1000,
            page,
            ordered_by: [
              {
                column: "id",
                order: "ASC",
              },
            ],
          },
          fetchPolicy: "network-only",
        });

        const retailers = data?.retailers?.data || [];
        const paginatorInfo = data?.retailers?.paginatorInfo;

        allRetailers.push(...retailers);

        hasMorePages = paginatorInfo?.hasMorePages ?? false;

        page++;
      }

      const dropdownData = allRetailers
        .filter((item) => item.user)
        .map((item) => ({
          label: item.user.name,
          value:
            valueType === "id"
              ? item.id
              : valueType === "user"
              ? item.user.id
              : item.name,
        }));

      setDropDownData(dropdownData);
    } catch (error) {
      showNotification({
        color: "red",
        title: "Error",
        message:
          error?.graphQLErrors?.[0]?.message ||
          "Failed to get retailers",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAllRetailers();
  }, []);

  const handleProductSelect = (value) => {
    onCardClick(value);

    if (setRetailerName) {
      const selectedRetailer = dropDownData.find(
        (d) => d.value === value
      );

      setRetailerName(selectedRetailer);
    }
  };

  return (
    <>
      {loading && <LoadingOverlay visible />}

      <Select
        placeholder="Filter By Retailer"
        data={dropDownData}
        value={retailer}
        onChange={handleProductSelect}
        clearable
        searchable
        required={required}
        withinPortal
      />
    </>
  );
}